import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { IS_PRIVATE_API } from '@personal-area/global/http/models';

import { AbtestingProfile } from '../models/abtesting-profile.dto';

@Injectable({ providedIn: 'root' })
export class ABTestApiService {
  constructor(protected _http: HttpClient) {}
  public getProfile(headers?: HttpHeaders): Observable<AbtestingProfile> {
    return this._http.request<AbtestingProfile>(
      'GET',
      `/2/v1/ab-testing/profile`,
      {
        headers,
        context: new HttpContext().set(IS_PRIVATE_API, true),
      },
    );
  }
}
